<template>
  <router-view />
</template>

<script>
export default {
  name: 'HotelsReservationsIndex'
}
</script>
